'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getQueryUrl = require('../utils/getQueryUrl'),
    flushUpdates = require('../utils/flushUpdates'),
    loadSoundCloudAPI = require('require-sdk')('https://w.soundcloud.com/player/api.js', 'SC'),
    SC = null,
    assign = require('react/lib/Object.assign'),
    { PropTypes } = React;

var OPTIONS = {
  'auto_play': false,
  'buying': false,
  'liking': false,
  'download': false,
  'sharing': false,
  'show_artwork': false,
  'show_comments': false,
  'show_playcount': false,
  'show_user': false
};

var SoundCloudPlayer = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    source: PropTypes.string.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    preload: PropTypes.bool,
    currentTime: PropTypes.number,
    onTimeUpdate: PropTypes.func.isRequired,
    onEnd: PropTypes.func.isRequired
  },

  getInitialState() {
    return {
      isInitialized: false,
      isReady: false
    };
  },

  componentDidMount() {
    var { source } = this.props,
        iframe = document.createElement('iframe');

    // Create iframe after mounting to work around WebKit bug
    // that caused <img onload> not firing for images added in same tick.

    // Put iframe into body to avoid layout issues in Firefox.
    // Note that with display:none sound wouldn't play in Firefox.

    iframe.style.position = 'absolute';
    iframe.style.pointerEvents = 'none';
    iframe.style.opacity = 0;
    iframe.style.left = '-9999px';
    iframe.style.top = '-9999px';
    iframe.style.width = 0;
    iframe.style.height = 0;
    iframe.style.zIndex = -999;
    iframe.src = getQueryUrl('//w.soundcloud.com/player/', assign({
      url: source
    }, OPTIONS));

    document.body.appendChild(iframe);
    this._iframe = iframe;

    loadSoundCloudAPI((error, api) => {
      if (!this.isMounted()) {
        return;
      }

      SC = api;

      this.widget = SC.Widget(iframe);

      this.widget.bind(SC.Widget.Events.PLAY, this.handlePlay);
      this.widget.bind(SC.Widget.Events.PLAY_PROGRESS, this.handleTimeUpdate);
      this.widget.bind(SC.Widget.Events.FINISH, this.handleMediaEnd);
      this.widget.bind(SC.Widget.Events.READY, () => this.handleWidgetIsReady(source));
    });
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.source !== this.props.source) {
      this.updateSource();
    }

    if (prevProps.isPlaying !== this.props.isPlaying) {
      this.updateIsPlaying();
    }

    if (this._lastReportedTime !== this.props.currentTime) {
      this.updateCurrentTime();
    }

    if (prevState.isReady !== this.state.isReady) {
      this.updateIsPlaying();
    }
  },

  componentWillUnmount() {
    if (this.widget) {
      this.widget.unbind(SC.Widget.Events.READY);
      this.widget.unbind(SC.Widget.Events.PLAY);
      this.widget.unbind(SC.Widget.Events.PLAY_PROGRESS);
      this.widget.unbind(SC.Widget.Events.FINISH);
    }

    document.body.removeChild(this._iframe);
  },

  render() {
    return null;
  },

  handleWidgetIsReady(source) {
    if (!this.isMounted()) {
      return;
    }

    this.widget.getDuration(duration => {
      if (!this.isMounted()) {
        return;
      }

      var sourceChanged = this.props.source !== source,
          isInitialized = this.state.isInitialized;

      if (this.state.isReady || sourceChanged && isInitialized) {
        return;
      }

      flushUpdates(() => {
        this.setState({
          trackDuration: duration,
          isReady: true,
          isInitialized: true
        }, () => {
          if (sourceChanged && !isInitialized) {
            this.updateSource();
          }
        });
      });
    });
  },

  handleTimeUpdate(time) {
    if (!this.isMounted()) {
      return;
    }

    if (this.state.trackDuration) {
      var currentTime = Math.floor(time.currentPosition / 1000),
          trackDuration = Math.floor(this.state.trackDuration / 1000);

      this._lastReportedTime = currentTime;
      this.props.onTimeUpdate({
        currentTime,
        trackDuration
      });
    }
  },

  handleMediaEnd() {
    if (!this.isMounted()) {
      return;
    }

    this.props.onEnd();
  },

  handlePlay() {
    if (!this.isMounted()) {
      return;
    }

    this.updateCurrentTime();
  },

  updateCurrentTime() {
    if (!this.state.isReady) {
      return;
    }

    this.widget.seekTo(this.props.currentTime * 1000);
  },

  updateIsPlaying() {
    if (!this.state.isReady) {
      return;
    }

    if (this.props.isPlaying) {
      this.widget.play();
    } else {
      this.widget.pause();
    }
  },

  updateSource() {
    if (!this.state.isInitialized) {
      return;
    }

    flushUpdates(() => {
      this.setState({
        isReady: false,
        trackDuration: null
      });
    });

    var { source } = this.props;

    this.widget.pause();
    this.widget.load(source, assign({
      callback: () => this.handleWidgetIsReady(source)
    }, OPTIONS));
  }
});

module.exports = SoundCloudPlayer;


/** WEBPACK FOOTER **
 ** ./atoms/SoundCloudPlayer.jsx
 **/